Shopware.Application.addServiceProviderDecorator('searchTypeService', (searchTypeService) => {
    searchTypeService.upsertType('tdlc_llm_model', {
        entityName: 'tdlc_llm_model',
        placeholderSnippet: 'TopdataLlmConnectSW6.topdata-llm-connect-llm-model.placeholderSearchBar',
        listingRoute: 'topdata.llm.connect.llm.model.list',
        hideOnGlobalSearchBar: true,
    });

    return searchTypeService;
});